import React from "react";
import Header from "../../components/shared/header/header";
import Sidebar from "../../components/shared/sidebar/sidebar";
import ClientViewCommunity from "../../components/clients-view/client-view-community";
import { DEFAULT_SIDEBAR_OPEN } from "../../helpers/constants";
import { getSingleCommunityPatrols } from "../../actions/community-patrol";

import { connect } from "react-redux";
import store from '../../store';
class MainCommunityContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isSidebarOpen: DEFAULT_SIDEBAR_OPEN,
            singleCell: {}
        }
    }

    
    componentDidMount(){
        if (this.props.match.params.id) {
            store.dispatch(getSingleCommunityPatrols(this.props.match.params.id) )           
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.communityPatrol !== this.props.communityPatrol){
            this.setState({singleCell: this.props.communityPatrol})
            
                      
        }
    }
    render() {
        return (
            <div className="admin-content" style={{ display: 'flex' }}>
                <Header handleSidebar={() => this.setState({ isSidebarOpen: !this.state.isSidebarOpen })} {...this.props} />
                <Sidebar isSidebarOpen={this.state.isSidebarOpen} {...this.props}>
                    <ClientViewCommunity cell={this.state.singleCell} {...this.props} />
                </Sidebar>
            </div>
        )
    }
}

const stateMap = (state) => {
    return {
        // cell: state.cell.diversion,
        communityPatrol: state.communityPatrol.communityPatrol
    };
};

export default connect(stateMap)(MainCommunityContainer);